// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"64":"52c725a2","226":"6548e7b4","241":"776eacc1","267":"938daada","351":"c6f26d56","548":"434eff52","585":"434eff52","644":"6b45e8e3","850":"d4c1e0d0","917":"8529ad1e"}[chunkId] + ".css";
};